import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment4Model} from "../state";


interface Assessment4DownloadCSVProps {
    assessment4Model: Assessment4Model;
}

function Assessment4DownloadCSV({ assessment4Model }: Assessment4DownloadCSVProps) {

    
    const csvData = [["Issue", "Action Plan"]];
        let rowIndex:number = 1;
        //iterate fuel types


        if(assessment4Model.checkAcctNumDesc != null)
        {
            csvData[rowIndex] =   ["Checking Routines for Household Account Numbers"
              , assessment4Model.checkAcctNumDesc];
            rowIndex++; 
        }
        if(assessment4Model.checkVendorCantFindAcctDesc != null)
        {
            csvData[rowIndex] =   ["Checking Routines for Missing Information in the Vendor System"
            , assessment4Model.checkVendorCantFindAcctDesc];
            rowIndex++; 
        }
        if(assessment4Model.checkShareHHDataReceivedEachVendorDesc != null)
        {
            csvData[rowIndex] =   ["Checking Percentage of Households with Data Received"
            , assessment4Model.checkShareHHDataReceivedEachVendorDesc];
            rowIndex++; 
        }
        if(assessment4Model.checkAvgHeatExpendVsSedsPerVendorDesc != null)
        {
            csvData[rowIndex] =   ["Checking Data Against the SEDS"
            , assessment4Model.checkAvgHeatExpendVsSedsPerVendorDesc];
            rowIndex++; 
        }
        if(assessment4Model.checkRangeReptByVendorsDesc != null)
        {
            csvData[rowIndex] =   ["Checking for Outliers"
            , assessment4Model.checkRangeReptByVendorsDesc];
            rowIndex++; 
        }
        if(assessment4Model.procsForReviewingResultsDesc != null)
        {
            csvData[rowIndex] =   ["Taking Action in the Event of Failed Checks"
            , assessment4Model.procsForReviewingResultsDesc];
            rowIndex++; 
        }
        if(assessment4Model.procsForAddingNewChecksDesc != null)
        {
            csvData[rowIndex] =   ["Adding Checks"
            , assessment4Model.procsForAddingNewChecksDesc];
            rowIndex++; 
        }
        if(assessment4Model.procsForRemovingChecksDesc != null)
        {
            csvData[rowIndex] =   ["Removing/Adjusting Checks"
            , assessment4Model.procsForRemovingChecksDesc];
            rowIndex++; 
        }

    return (
      <CSVLink data={csvData} filename="MainHeatingFuelAssessment4.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment4DownloadCSV;
